<template lang='pug'>
  .rsv-msgs.component
    rsv-msg.msg(
      v-for='m,i in msgs'
      :rsv='rsv'
      :account='account'
      :msg='m'
      :key='m.id'
      @updated='key++'
    )

    form#send-msg(
      v-if='dispatchable'
      ref='form'
    )
      textarea(
          required
          v-model='message'
          :placeholder='$t("Your message... (*Required)")'
          :class='{ invalid: invalid }'
        )
      bf-flex.buttons(:class='{ "space-between": cancelable, centered: !cancelable }')
        bf-button.small.tall.narrowest(
          v-if='cancelable'
          @click.native='cancel'
        )
          template(v-slot:text) {{ $t('Send Cancel Request') }}
        bf-button.small.tall.narrowest.send-msg(@click.native='send')
          template(v-slot:text) {{ $t('Send Message') }}
</template>

<script>
  import { db } from '@/main'
  import RsvMsg from '@/components/rsv-msg'

  export default {
    name: 'rsv-msgs.component',

    props: ['rsv', 'account'],

    components: {
      RsvMsg
    },

    data() {
      return {
        message: '',
        msgs: [],
        invalid: false,
        key: 0
      }
    },

    firestore() {
      return {
        msgs: {
          ref: db.collection('reservations').doc( this.rsv.id ).collection('messages').orderBy('sent.on'),
          resolve: msgs => {
            msgs.forEach( async m => {
              if ( m.sent.by.id != this.rsv.account_id ) {
                let biz = await db.collection( 'businesses' ).doc( this.rsv.business_id ).get()
                m.sent.by.name = biz.data().name
              }
            })
          }
        }
      }
    },

    computed: {
      valid() {
        return !this.invalid
      },

      cancelable() {
        return !this.msgs.filter( m => m.cancellation && !m.cancellation.voided ).length
      },

      dispatchable() {
        return this.rsv.datetime.end.toDate() > new Date() && this.rsv.status != 'Canceled'
      }
    },

    watch: {
      message(curr, prev) {
        if ( curr ) this.invalid = false
      }
    },

    methods: {
      binder() {
        this.$binding( 'msgs', db.collection('reservations').doc( this.rsv.id ).collection('messages') ).then( msgs =>
          msgs.sort( (m0, m1) => m0.sent.on.toDate() - m1.sent.on.toDate() )
        )
      },

      validate() {
        if ( !this.message ) this.invalid = true
      },

      send() {
        this.validate()
        if ( this.valid ) db.collection('reservations').doc(this.rsv.id).collection('messages').add({
          cancellation: false,
          content: this.message,
          sent: { by: this.account, on: new Date() },
        }).then( () => this.message = '' )
      },

      cancel() {
        this.validate()
        if ( this.valid ) {
          db.collection('reservations').doc(this.rsv.id).collection('messages').add({
            cancellation: { confirmed: false, voided: false },
            content: this.message,
            sent: { by: this.account, on: new Date() },
          }).then( () => this.message = '' )

          db.collection('reservations').doc( this.rsv.id ).update({ status: 'Pending Cancellation' })
        }
      }
    }
  }
</script>

<style scoped lang='stylus'>
  textarea
    border solid 1px rgba(0 0 0 0.5)
    border-radius 5px
    padding 8px
    margin-top 10px
    width 98%
    
  .buttons
    padding 16px
    .send-msg
      // margin 0 auto

  .invalid
    border 1.5px solid red
</style>
